export default {
  dashboard: {
    catalog_widget: {
      header: {
        title: 'Su catálogo',
      },
      body: {
        title_published_items: 'Ítems activos',
        title_unpublished_items: 'Ítems inactivos',
        title_actived_users: 'Usuarios activos',
      },
    },
    match_widget: {
      header: {
        title: 'Actividad de su catálogo',
      },
      body: {
        appearances_in_search: 'Apariciones en Búsqueda',
        items_with_match: 'Ítems con MATCH',
        items_displayed: 'Ítems visualizados',
        buyers_who_viewed_your_items: 'Compradores que vieron sus ítems',
      },
    },
    titles: {
      news: 'Novedades',
      tenders: 'Materiales cotizados en UNILINK​',
      orders: 'Montos cotizados en UNILINK​',
    },
    consult: {
      tooltip: 'Puedes consultar por todos los datos de UNILINK o los datos asociados a tu empresa',
      transactions: 'Puedes consultar por materiales o categorías cotizadas por UNILINK, ya sea para toda la comunidad o sólo para tu empresa​',
      volume: 'Puedes consultar por los valores cotizados en UNILINK, ya sea para toda la comunidad o sólo para tu empresa​',
    },
    noData: 'No hay datos disponibles para mostrar',
    details: 'Ver Detalles',
    search: 'Buscar',
    dates: {
      from: 'Fecha de inicio',
      to: 'Fecha de fin',
      filterInfo: 'Para tu consulta puedes filtrar por rango de fecha y por categoría',
      begining: 'Desde',
      end: 'Hasta',
    },
    myCompany: 'Mi Empresa',
    activity: 'Actividad en Cotizaciones',
    itemsName: 'Nombre del item',
    companyName: 'Nombre de la empresa',
    allCategories: 'Todas las categorías',
    companyBuyer: 'Empresa compradora',
    table: {
      CompradorNombre: 'Nombre del comprador',
      CategoriaId: 'Categoria ID',
      CategoriaNombre: 'Categoria Nombre',
      ItemDescripcion: 'Item Descripcion',
      ItemCantidad: 'Item Cantidad',
      ItemPosicion: 'Item Posición',
      RfqFechaCreacion: 'Rfq Fecha Creación',
      RfqFechaCierre: 'Rfq Fecha Cierre',
      RfqPrecio: 'Rfq Precio',
      RfqMoneda: 'Rfq Moneda',
    },
    excel: {
      generate: 'Generar Excel',
      noData: 'No hay datos disponibles para generar el reporte',
    },
  },
};



// WEBPACK FOOTER //
// ./src/i18n/es-cl/dashboard.js